import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { useActiveProduct } from '@legacy/contexts/activeProductContext'
import { useSelectedPartner } from '@legacy/contexts/selectedPartnerContext'
import usePageTitle from '@legacy/hooks/usePageTitle'

import DocumentTitle from './DocumentTitle'
import * as routePaths from './Website/Routes/definitions'

const DocumentTitleWithProduct: React.FC<React.PropsWithChildren<{ title?: string }>> = ({ title }) => {
  const { product } = useActiveProduct()
  const { pathname } = useLocation()
  const { partner } = useSelectedPartner()
  const { t } = useTranslation()

  const productAndPartner = partner?.entityName ? `${product.name} - ${partner.entityName}` : product.name

  const scenarios = useMemo(
    () => [
      { path: routePaths.home(), title: t('titles.home', { name: productAndPartner }) },
      { path: routePaths.quoteDetails(), title: t('titles.quoteDetails', { name: productAndPartner }) },
      { path: routePaths.quoteParameters(), title: t('titles.quoteParameters', { name: productAndPartner }) },
      { path: routePaths.bindAndPay(), title: t('titles.bindAndPay', { name: productAndPartner }) },
      { path: routePaths.policyCreated(), title: t('titles.confirmed', { name: productAndPartner }) },
      { path: routePaths.authorizationSubmitted(), title: t('titles.confirmed', { name: productAndPartner }) },
    ],
    [productAndPartner, t],
  )

  const pageTitle = usePageTitle({ scenarios, pathname })
  const titleFromProps = title && `${title} - ${productAndPartner}`

  const documentTitle = titleFromProps || pageTitle || ''

  return <DocumentTitle title={documentTitle} />
}

export default DocumentTitleWithProduct
